import { CorvetteTheme } from './corvette/types'
import { GolfTheme } from './golf/types'

export const multiplyRems = (rem: string, multiplier: number): string => {
  const numericValue = parseFloat(rem)
  return numericValue * multiplier + 'rem'
}
export const importCorvetteTheme = async (projectName: string = 'generic') => {
  return {
    colors: await import(`@kodix/one.corvette.color-schemes/${projectName}/config/colors.json`),
    'font-face': await import(`@kodix/one.corvette.color-schemes/${projectName}/config/font-face.json`),
    grid: await import(`@kodix/one.corvette.color-schemes/${projectName}/config/grid.json`),
    shadows: await import(`@kodix/one.corvette.color-schemes/${projectName}/config/shadows.json`),
    spacing: await import(`@kodix/one.corvette.color-schemes/${projectName}/config/spacing.json`),
    'text-styles': await import(`@kodix/one.corvette.color-schemes/${projectName}/config/text-styles.json`),
    transition: await import(`@kodix/one.corvette.color-schemes/${projectName}/config/transition.json`),
    typography: await import(`@kodix/one.corvette.color-schemes/${projectName}/config/typography.json`)
  }
}

export const isGolfTheme = (theme: GolfTheme | CorvetteTheme): theme is GolfTheme => {
  if ('colors' in theme) {
    return false
  } else {
    return true
  }
}
